// extracted by mini-css-extract-plugin
export default {"variant":"Variant_variant__xzB5y","varNumber":"Variant_varNumber__ToeSB","varTitle":"Variant_varTitle__ExYiZ"};